import { AuthorFragmentFragment } from 'gql/graphql-operations';

const typeByKey = {
  technologies: 'tech',
  solutions: 'solution',
  generalTags: 'general',
} as const;

type Key = keyof typeof typeByKey;
export type WpTag = { name: string; url: string; type: (typeof typeByKey)[Key]; databaseId: number };

const keys = ['technologies', 'solutions', 'generalTags'] as const;

export function getAllTags(author: AuthorFragmentFragment): WpTag[] {
  return keys.flatMap((key) =>
    (author.customFields?.[key] ?? []).flatMap((item: any) => {
      const databaseId = item?.databaseId;
      const name = item?.name;
      const url = item?.[key]?.url;
      return name && url ? [{ name, url, type: typeByKey[key], databaseId }] : [];
    }),
  );
}
